import { EnvironmentVariables } from "./environment";

// return true if show feature
export const featureFlags = {
  courseInvitations: EnvironmentVariables.IN_DEV_OR_TEST_ENV,
  courseOrders: EnvironmentVariables.NOT_IN_PROD_ENV,
  not_in_prod_or_staging: EnvironmentVariables.NOT_IN_PROD_OR_STAGING,
} as const;
